import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApisRequestService } from './apis-request.service';
import { PepCheckResult } from '../types/pep-check-result';

@Injectable()
export class ApisService {
  constructor(private request: ApisRequestService) {}

  checkPepStatus(egn: string, name?: string): Observable<PepCheckResult> {
    return this.request.post(['apis', 'peps', 'check', 'status'], {
      body: { ident: egn, searchText: name },
    });
  }

  getPepReport(civilId: string): Observable<any> {
    return this.request.get(['apis', 'peps', 'report', civilId]);
  }

  searchRegdata(
    egn: string,
    phoneNumber: string,
    force: boolean = false,
    pageNum: number = 1,
    pageSize: number = 100
  ): Observable<any> {
    return this.request.post(['apis', 'regdata', 'search', 'egn'], {
      body: { egn, phoneNumber, pageNum, pageSize, force },
    });
  }
}
